import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { ApiGatewayService } from './api-gateway.service';
import { LocalStorageService } from './local-storage.service';
import { ServiceLocation } from '../models/service-location.model';

@Injectable({ providedIn: 'root' })
export class ServiceLocationService {
  private readonly apiGatewayService = inject(ApiGatewayService);
  private readonly localStorageService = inject(LocalStorageService);

  private serviceLocationsSubject = new BehaviorSubject<ServiceLocation[] | null>(null);
  serviceLocations$ = this.serviceLocationsSubject.asObservable();

  async getServiceLocationsAsync(): Promise<ServiceLocation[]> {
    const serviceLocations$ = this.apiGatewayService.get<ServiceLocation[]>(
      'oss/accounts/serviceLocations',
      '1.0.0',
      {},
    );
    const serviceLocations = await firstValueFrom(serviceLocations$);
    await this.localStorageService.setServiceLocations(serviceLocations);
    this.serviceLocationsSubject.next(serviceLocations);
    return serviceLocations;
  }

  clearServiceLocations(): void {
    this.serviceLocationsSubject.next(null);
  }
}
